<template>
    <div class="md-layout">
        <div class="md-layout-item md-size-100">
            <md-card>
                <md-card-header class="md-card-header-icon md-card-header-blue">
                    <div class="card-icon">
                        <md-icon>rule</md-icon>
                    </div>
                    <h4 class="title">Attendances List</h4>
                </md-card-header>
                <md-card-content>
                    <div class="text-right">
                        <md-button @click="goToAdd" class="md-primary md-dense">
                            Add Manual Attendance
                        </md-button>
                    </div>
                    <md-table
                            :value="attendances"
                            :md-sort.sync="sortation.field"
                            :md-sort-order.sync="sortation.order"
                            :md-sort-fn="customSort"
                            class="paginated-table table-striped table-hover"
                    >
                        <md-table-toolbar>
                            <md-field>
                                <label>Per page</label>
                                <md-select v-model="pagination.perPage" name="pages">
                                    <md-option
                                            v-for="item in pagination.perPageOptions"
                                            :key="item"
                                            :label="item"
                                            :value="item">
                                        {{ item }}
                                    </md-option>
                                </md-select>
                            </md-field>

                            <md-field>
                                <md-input
                                        v-model="query"
                                        type="search"
                                        class="mb-3"
                                        clearable
                                        style="width: 200px"
                                        placeholder="Search ..."
                                >
                                </md-input>
                            </md-field>
                        </md-table-toolbar>

                        <md-table-empty-state
                                md-label="No item found"
                                :md-description="`No data found for this query. Try a different search term.`">

                        </md-table-empty-state>

                        <md-table-row slot="md-table-row" slot-scope="{ item }">
                            <md-table-cell md-label="Name" md-sort-by="name">{{item.labourer_name}}</md-table-cell>
                            <md-table-cell md-label="Check In Time" md-sort-by="checkin">{{item.checkin_display}}
                            </md-table-cell>
                            <md-table-cell md-label="Takeon Status" md-sort-by="checkin">
                                <badge :type="statusBadge(item.takeon_status)">{{item.takeon_status}}</badge>
                                <div class="mt-2">{{item.takeon_number}}</div>
                            </md-table-cell>
                            <md-table-cell md-label="Checkin Method" md-sort-by="method">{{item.method}}</md-table-cell>
                            <md-table-cell md-label="Actions">
                                <md-button
                                        class="md-icon-button md-raised md-round md-info"
                                        @click="goToView(item.id)"
                                        style="margin: 0.2rem"
                                >
                                    <md-icon>visibility</md-icon>
                                </md-button>
                                <md-button
                                        class="md-icon-button md-raised md-round md-warning"
                                        @click="goToEdit(item.id)"
                                        style="margin: 0.2rem"
                                >
                                    <md-icon>edit</md-icon>
                                </md-button>
                                <md-button
                                        class="md-icon-button md-raised md-round md-danger"
                                        @click="destroy(item)"
                                        style="margin: 0.2rem"
                                >
                                    <md-icon>delete</md-icon>
                                </md-button>
                            </md-table-cell>
                        </md-table-row>
                    </md-table>
                </md-card-content>

                <md-card-actions md-alignment="space-between">
                    <div class="">
                        <p class="card-category">
                            Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
                        </p>
                    </div>
                    <pagination
                            class="pagination-no-border pagination-success"
                            v-model="pagination.currentPage"
                            :per-page="pagination.perPage"
                            :total="total"
                    />
                </md-card-actions>
            </md-card>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import { Badge, Pagination } from '@/components';
import Swal from 'sweetalert2';

export default {
    components: {
        pagination: Pagination, Badge
    },

    data: () => ({
        attendances: [],
        footerTable: [
            'Name',
            'Short Name',
            'Created At',
            'Actions'
        ],

        query: null,

        sortation: {
            field: 'created_at',
            order: 'asc',
        },

        pagination: {
            perPage: 10,
            currentPage: 1,
            perPageOptions: [5, 10, 25, 50],
        },

        total: 0,
    }),

    computed: {
        sort () {
            if (this.sortation.order === 'desc') {
                return `-${this.sortation.field}`;
            }
            return this.sortation.field;
        },

        from () {
            return this.pagination.perPage * (this.pagination.currentPage - 1);
        },

        to () {
            let highBound = this.from + this.pagination.perPage;
            if (this.total < highBound) {
                highBound = this.total;
            }
            return highBound;
        },
    },

    watch: {
        query: {
            handler: 'getListDebounced',
            immediate: true,
        },
        sortation: {
            handler: 'getList',
            immediate: false,
            deep: true,
        },
        pagination: {
            handler: 'getList',
            immediate: false,
            deep: true,
        },
    },

    methods: {
        getListDebounced: _.debounce(function () {
            this.getList();
        }, 300),

        async getList () {
            let params = {
                include: 'labourer,labourerSchedule',
                ...(this.sort ? { sort: this.sort } : {}),
                filter: {
                    ...(this.query ? { queryKey: this.query } : {}),
                },
                page: {
                    number: this.pagination.currentPage,
                    size: this.pagination.perPage,
                },
            };

            try {
                await this.$store.dispatch('labourerAttendances/list', params);
                this.attendances = this.$store.getters['labourerAttendances/list'];
                this.takeonStatus();
                this.total = this.$store.getters['labourerAttendances/listTotal'];
            } catch (e) {
                await this.$store.dispatch(
                    'alerts/alert', e.response
                );
            }
        },

        async destroy (attendance) {
            const confirmation = await Swal.fire({
                title: 'Delete Attendance Record?',
                text: `Delete attendance record for ${attendance.labourer_name} check in at ${attendance.checkin}`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, Cancel it!',
                cancelButtonText: 'No, keep it',
                confirmButtonClass: 'md-button md-success',
                cancelButtonClass: 'md-button md-danger',
                backdrop: false
            });

            if (confirmation.value === true) {
                try {
                    await this.$store.dispatch('labourerAttendances/destroy', attendance.id);
                    await this.$store.dispatch(
                        'alerts/success',
                        'Attendance deleted successfully.'
                    );
                    await this.getList();
                } catch (e) {
                    await this.$store.dispatch(
                        'alerts/alert',
                        e.response
                    );
                }
            }
        },

        takeonStatus () {
            // return "Mzuri"
            this.attendances = this.attendances.map(attendance => {
                const hoursDifferent = this.diff_hours(attendance.checkin);
                if (attendance.labourerSchedule.id.length > 0) {
                    console.log(attendance.labourerSchedule);
                    attendance.takeon_status = 'Assigned';
                    attendance.takeon_number = attendance.labourerSchedule.takeon_number;
                } else {
                    if (hoursDifferent > 5) {
                        attendance.takeon_status = 'Unsigned';
                    } else {
                        attendance.takeon_status = 'Pending';
                    }
                }
                return attendance;
            });
        },

        diff_hours (checkinTime) {
            let dt1 = new Date(checkinTime);
            let dt2 = new Date();
            let diff = (dt2.getTime() - dt1.getTime()) / 1000;
            diff /= (60 * 60);
            console.log(dt1);
            console.log(dt2);
            return Math.abs(Math.round(diff));
        },
        statusBadge (status) {
            if (status === 'Assigned') {
                return 'success';
            } else if (status === 'Unsigned') {
                return 'danger';
            } else if (status === 'pending') {
                return 'warning';
            }
        },

        goToAdd () {
            this.$router.push({ name: 'Add Labourer Attendance' });
        },

        goToEdit (id) {
            this.$router.push({ name: 'Edit Labourer Attendance', params: { id } });
        },
        goToView (id) {
            this.$router.push({ name: 'View Labourer Attendance', params: { id } });
        },

        customSort () {
            return false;
        }
        ,

    },
}
;
</script>
